import { createFileRoute } from "@tanstack/react-router";

import { createHead } from "@/components/createHead";
import { GetStartedNewsroom } from "@/components/GetStartedNewsroom";
import MarketingFooter from "@/components/MarketingFooter";
import { MarketingNavBar } from "@/components/MarketingNavBar";
import { Picture } from "@/components/Picture";
import { SimpleNode } from "@/components/SimpleEditor/SimpleNode";
import { StickyNav } from "@/components/StickyNav";
import { ButtonAnchor, ButtonLink } from "@/components/ui/button";
import carrot from "@/images/carrot.png?w=500;900;1200&format=avif;webp;jpg&as=picture";
/* eslint-disable import-x/no-duplicates */
// @ts-expect-error TODO: fix this
import card3 from "@/images/illustration.png?slice=1&height=200&width=344&x=1009&y=4742";
// @ts-expect-error TODO: fix this
import card4 from "@/images/illustration.png?slice=1&height=200&width=344&x=1366&y= 1883";
// @ts-expect-error TODO: fix this
import card1 from "@/images/illustration.png?slice=1&height=200&width=344&x=1366&y=2170";
// @ts-expect-error TODO: fix this
import card2 from "@/images/illustration.png?slice=1&height=200&width=344&x=1580&y=2678";
// @ts-expect-error TODO: fix this
import heroIllustration from "@/images/illustration.png?slice=1&x=150&y=1650&height=1000&width=1000";
/* eslint-enable import-x/no-duplicates */
import moon from "@/images/moon.png?w=500;900;1200&format=avif;webp;jpg&as=picture";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/brands")({
  component: RouteComponent,
  head: ({ match: { pathname } }) =>
    createHead({
      title: "Brands | Graze",
      description:
        "Custom feeds built for brands. Reach your audience (the real one.)",
      ogTitle: "Brands | Graze",
      ogImage: "/brands.png",
      pathname,
    }),
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-slate-app instrument-sans text-slate-normal">
      <header className="bg-slate-9 dark:bg-slatedark-9 text-slate-contrast dark:text-slatedark-contrast">
        <div className="flex items-center gap-12 mx-auto container px-4">
          <div className="h-full items-center justify-center hidden md:flex flex-1 @container">
            <div className="relative flex items-center justify-center">
              <div
                className="sharp-grotesk text-[100cqw] leading-[0.9] big-g-scroll"
                style={{
                  backgroundImage: `url(${heroIllustration})`,
                  backgroundSize: "100cqw",
                  backgroundClip: "text",
                  color: "transparent",
                  textShadow: "none",
                }}
              >
                G
              </div>
              <div className="absolute right-[4.5cqw] bottom-[5cqw] text-slate-12 instrument-serif text-[15cqw] italic">
                Graze
              </div>
            </div>
          </div>
          <div className="flex-1 py-6 md:py-10 flex flex-col @container">
            <div className="flex mb-2 md:mb-16 md:justify-end sticky top-[-100%]">
              <MarketingNavBar onlyNav variant="light" />
            </div>
            <h1 className="text-[14cqw] instrument-serif bold mb-8 leading-none">
              Custom Feeds Built for Brands
            </h1>
            <div className="mb-6 md:mb-8 flex flex-col gap-4 max-w-[68ch] border-2 border-slate-11 dark:border-slated-11 rounded-xl p-4 bg-white/30 dark:bg-black/30">
              <p className="text-xl md:text-2xl font-medium">
                Reach your audience (the real one.)
              </p>
            </div>
            <GetStartedNewsroom />
          </div>
        </div>
      </header>

      <StickyNav variant="slate" />

      <section className="py-6 md:py-16">
        <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-16">
          <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
            Why brands are building custom feeds
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
            <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
              <div
                className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${card1}')`,
                }}
              ></div>
              <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                <div className="text-3xl md:text-4xl font-bold instrument-serif">
                  Own your discovery
                </div>
                <div className="text-lg">
                  Your brand, not an algorithm, decides what rises to the top
                </div>
              </div>
            </div>
            <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
              <div
                className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${card2}')`,
                }}
              ></div>
              <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                <div className="text-3xl md:text-4xl font-bold instrument-serif">
                  Connect with quality audiences
                </div>
                <div className="text-lg">
                  Reach high-intent users who chose to follow your feed
                </div>
              </div>
            </div>
            <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
              <div
                className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${card3}')`,
                }}
              ></div>
              <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                <div className="text-3xl md:text-4xl font-bold instrument-serif">
                  Control your narrative
                </div>
                <div className="text-lg">
                  Curate content that reflects your values and showcases your
                  best work
                </div>
              </div>
            </div>
            <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
              <div
                className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${card4}')`,
                }}
              ></div>
              <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                <div className="text-3xl md:text-4xl font-bold instrument-serif">
                  Drive direct traffic
                </div>
                <div className="text-lg">
                  Every click goes straight to your properties with full
                  attribution
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 bg-teal-4 dark:bg-tealdark-4">
        <div className="container @container mx-auto grid relative z-0 px-4">
          <div
            className="flex flex-col justify-center items-center lg:container mx-auto gap-4 bg-position-[-11cqw_-314cqw]"
            style={{
              textShadow: "0 0 0 rgba(255, 255, 255, 0.1)",
            }}
          >
            <div className="leading-relaxed instrument-serif w-full text-[4cqw] md:text-[3.2cqw] text-center">
              Custom feeds help brands build a direct connection with their
              audience at scale.
              <br />
              Without relying on the algorithm.
            </div>
          </div>
        </div>
      </section>

      <section className="py-6 md:py-16 bg-slate-3 dark:bg-slatedark-3">
        <div className="container mx-auto p-4 md:px-12 flex flex-col lg:flex-row gap-8 md:gap-16">
          <div className="flex flex-col gap-8 md:gap-12 flex-1">
            <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
              Real Results
            </h2>
            <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
              <div className="flex-1 flex flex-col gap-10">
                <p className="text-xl md:text-3xl max-w-[68ch] leading-relaxed">
                  Turn engagement into ownership. Convert fans, creators, and
                  customers into a loyal audience without playing by platform
                  rules.
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-4 shrink-0 flex-1">
            <div className="shrink-0 md:flex-1 flex items-center bg-orange-10 dark:bg-orangedark-10 text-orange-contrast dark:text-orangedark-contrast @ border-2 border-orange-11 dark:border-orangedark-11 rounded-lg @container">
              <div className="p-8 flex flex-col items-end gap-8">
                <div className="flex items-center md:items-start gap-8">
                  <div
                    className={cn([
                      "shrink-0 h-[100px] w-[100px] @container bg-slate-subtle flex items-center justify-center rounded-full",
                      "border-2 border-slate-7 dark:border-slatedark-7",
                    ])}
                  >
                    <span className="text-[70cqw]">
                      <img
                        src="https://cdn.bsky.app/img/avatar/plain/did:plc:2c7afebp7enocvuvbp4u5yam/bafkreib2uuh3fvkgpmaue4gac53ihsagj6lpjwbrwyckaiuxgf3pnlpsuy@jpeg"
                        alt="The logo of The San Francisco Standard"
                        className="h-full w-full rounded-full"
                      />
                    </span>
                  </div>
                  <div className="text-lg md:text-xl leading-relaxed">
                    Graze gave us a way to experiment with our editorial
                    approach and quickly learn what resonates without relying on
                    Twitter's or Meta's black box.
                  </div>
                </div>
                <div className="text-lg md:text-xl instrument-serif">
                  ~ Addison Nugent - Audience Editor,{" "}
                  <a
                    href="https://sfstandard.com/"
                    className="underline decoration-wavy underline-offset-8 hover:decoration-solid"
                  >
                    The San Francisco Standard
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-6 md:py-16 relative">
        <div className="container mx-auto p-4 md:px-16 flex flex-col gap-8 md:gap-16">
          <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
            What You Can Do With Graze
          </h2>

          <div className="flex flex-col md:flex-row flex-1 gap-8 md:gap-16">
            <ul className="flex flex-col gap-4 flex-2">
              <li>
                <SimpleNode isReadonly title="Embed feeds" variant="yellow">
                  Take your feed with you and embed it on your website, campaign
                  pages, or partner sites
                </SimpleNode>
              </li>
              <li>
                <SimpleNode isReadonly variant="plum" title="Powerful curation">
                  Curate by tags, creators, or categories, hand-pick posts
                  yourself, or even use AI to do it for you
                </SimpleNode>
              </li>
              <li>
                <SimpleNode
                  isReadonly
                  variant="sky"
                  title="Automate feeds updates"
                >
                  Or take full control when you need it{" —  "}add posts
                  manually, or even remove posts from your feeds entirely
                </SimpleNode>
              </li>
              <li>
                <SimpleNode isReadonly variant="green" title="Monetize">
                  Sustainably monetize with advertisers who actually value your
                  content and resonate with your audience
                </SimpleNode>
              </li>
            </ul>
            <div className="flex justify-center items-center flex-1">
              <Picture src={moon} alt="" className="max-h-[300px] w-auto" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-6 md:py-16 bg-teal-9 dark:bg-tealdark-9 text-teal-contrast dark:text-tealdark-contrast relative">
        <div className="flex items-center justify-center w-[150px] md:w-[15%] mx-auto">
          <Picture src={carrot} alt="" />
        </div>
        <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-12">
          <h2 className="text-4xl md:text-6xl font-bold instrument-serif text-center">
            Ready to reclaim your audience?
          </h2>
          <p className="text-lg md:text-xl max-w-[80ch] leading-relaxed mx-auto">
            Your community is already out there. Custom feeds help them find you
            again—in a space you actually control.
          </p>
          <div className="flex gap-4 justify-center">
            <ButtonAnchor
              href="mailto:admin@graze.social"
              className="text-orange-normal"
              variant="outline"
            >
              Talk to our team
            </ButtonAnchor>
            <ButtonLink to="/ads">Get Started</ButtonLink>
          </div>
        </div>
      </section>

      <MarketingFooter showStartSection={false} showCarrot={false} />
    </div>
  );
}
